module.exports = __webpack_public_path__ + "img/DE03923.3bfe10b9.png";